module.exports = __webpack_public_path__ + "assets/img/00026.9aad051b.png";